import Class from "./Class";

const mixin = function(target, attrs) {
    if (attrs) {
        Object.keys(attrs).forEach(function(key) {
            target[key] = attrs[key];
        });
    }
    return target;
};

const Visitor = new Class({
    visit: function(node) {
        const method = this["visit:" + node.type];
        if (typeof method === "function") {
            return method.call(this, node.visit(this));
        }
        return this.defaultVisit(node.visit(this));
    },

    defaultVisit: function(node) {
        throw new Error("unknown node type '" + node.type + "'");
    }
});

const Value = new Class({
    initialize: function(type, attrs) {
        this.type = type;

        mixin(this, attrs);
        this._attrs = mixin({}, attrs);
    },

    visit: function(visitor) {
        return this;
    }
});

const Unary = new Class({
    Extends: Value,

    initialize: function(type, value, attrs) {
        Value.call(this, type, attrs);

        this.value = value;
    },

    visit: function(visitor) {
        const value = visitor.visit(this.value);
        return new Unary(this.type, value, this._attrs);
    }
});

const Binary = new Class({
    Extends: Value,

    initialize: function(type, left, right, attrs) {
        Value.call(this, type, attrs);

        this.left = left;
        this.right = right;
    },

    visit: function(visitor) {
        const left = visitor.visit(this.left);
        const right = visitor.visit(this.right);
        return new Binary(this.type, left, right, this._attrs);
    }
});

const NAry = new Class({
    Extends: Value,

    initialize: function(type, values, attrs) {
        Value.call(this, type, attrs);

        this.values = values;
    },

    visit: function(visitor) {
        const values = this.values.map(function(value) {
            return visitor.visit(value);
        });
        return new NAry(this.type, values, this._attrs);
    }
});

export default {
    "Value": Value,
    "Unary": Unary,
    "Binary": Binary,
    "NAry": NAry,
    "Visitor": Visitor
};



// WEBPACK FOOTER //
// ./src/abusesa-js/AST.js